module.exports = {"title":"Formulaire de demande de démo","disclaimer":"Avis de non-responsabilité: Les modèles et politiques de HRdownloads.com sont fournis aux clients de notre service. Les clients peuvent utiliser ce document tel quel, ou comme point de départ pour leurs propres documents. HRdownloads.com n’assume aucune responsabilité quant à l’application ou l’efficacité de ses modèles et politiques. Consultez toujours un conseiller juridique avant de mettre en œuvre toute nouvelle politique ou procédure dans votre organisation."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr/request-demo.json
// module id = Quxk
// module chunks = 0